import { JSONContent } from "@tiptap/react"
import { RcFile } from 'antd/es/upload';
import { DateTime } from 'luxon';

export const defaultJsonContentTiptap: JSONContent = {
    "type": "doc",
    "content": [
        {
            "type": "heading",
            "attrs": {
                "level": 3
            },
            "content": [
                {
                    "type": "text",
                    "text": "Welcome!"
                }
            ]
        },
        {
            "type": "paragraph",
            "content": [
                {
                    "type": "text",
                    "text": "This is the Halcyon Experience!"
                }
            ]
        }
    ]
}

export const defaultEmailJsonContentTiptap: JSONContent = {
    "type": "doc",
    "content": [
        {
            "type": "heading",
            "attrs": {
                "textAlign": "center",
                "level": 1
            },
            "content": [
                {
                    "type": "text",
                    "text": "Welcome to |clientName|"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "Hello |applicantName|,"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "We're excited to have you on board! Click the secure link below to access your account."
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "marks": [
                        {
                            "type": "link",
                            "attrs": {
                                "href": "|magicLink|",
                                "target": "_blank",
                                "rel": "noopener noreferrer",
                                "class": "email-button"
                            }
                        }
                    ],
                    "text": "Access Your Account"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "This secure link will expire in 15 minutes for your protection."
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "If the button doesn't work, copy and paste this link:"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "marks": [
                        {
                            "type": "link",
                            "attrs": {
                                "href": "|magicLink|",
                                "target": "_blank",
                                "rel": "noopener noreferrer",
                                "class": "link-text"
                            }
                        }
                    ],
                    "text": "|magicLink|"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "Need help? Contact our support team anytime."
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "Best regards,\nThe |clientName| Team"
                }
            ]
        },
        {
            "type": "paragraph",
            "attrs": {
                "textAlign": "center"
            },
            "content": [
                {
                    "type": "text",
                    "text": "If you didn't request this, please ignore this email."
                }
            ]
        }
    ]
}

export const modernEmailStyles = `
<style>
    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        line-height: 1.6;
        color: #333;
        background-color: #f4f4f4;
        margin: 0;
        padding: 0;
    }
    .email-wrapper {
        max-width: 600px;
        margin: 0 auto;
        padding: 20px;
    }
    .email-content {
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        padding: 40px;
    }
    h1 {
        color: #2c3e50;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 20px;
    }
    p {
        margin: 16px 0;
        font-size: 16px;
    }
    .email-button {
        display: inline-block;
        padding: 14px 32px;
        margin: 24px 0;
        background-color: #1890ff;
        color: #ffffff !important;
        text-decoration: none;
        border-radius: 6px;
        font-weight: 500;
        font-size: 16px;
        transition: background-color 0.3s ease;
    }
    .email-button:hover {
        background-color: #40a9ff;
    }
    .footer-text {
        font-size: 14px;
        color: #666;
        margin-top: 32px;
    }
    .link-text {
        word-break: break-all;
        font-size: 14px;
        color: #1890ff;
    }
</style>
`;

export const isExpired = (token: string | null) => {
    if (token) {
        const splited = token.split('.');
        if (splited.length > 1) {
            const { exp } = JSON.parse(atob(splited[1]));
            if (exp) {
                const dt = DateTime.fromSeconds(JSON.parse(atob(splited[1])).exp);
                const diffNow = dt.diffNow();
                if (diffNow.valueOf() <= 0) return true;
                else return false;
            }
        }
    }
    return true;
}

export const tokenApplicantId = (token: string | null) => {
    if (token) {
        const splited = token.split('.');
        if (splited.length > 1) {
            const { aid } = JSON.parse(atob(splited[1]));
            return aid ?? null;
        }
    }
    return null;
}

export const tokenSub = (token: string | null) => {
    if (token) {
        const splited = token.split('.');
        if (splited.length > 1) {
            const { sub } = JSON.parse(atob(splited[1]));
            return sub ?? null;
        }
    }
    return null;
}


export const capitalizeFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// @ts-expect-error typescript does not like this
String.prototype.replaceAt = function (index: number, replacement: string) {
    return this.substring(0, index) + replacement + this.substring(index + replacement.length);
}

export const states = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
];

export function getBase64(file: RcFile | File) {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
}

export async function getFileJSON<T = any>(file: RcFile): Promise<T> {
    const dataUrl = await getBase64(file);
    // Extract base64 content from data URL (format: data:*/*;base64,<content>)
    const base64Content = dataUrl.split(',')[1];
    // Decode base64 to string using browser-compatible atob
    const jsonString = atob(base64Content);
    return JSON.parse(jsonString);
}

export const getSignatureKey = () => {
    const randomBytes = new Uint8Array(24); // 16 bytes (128 bits)

    window.crypto.getRandomValues(randomBytes);

    const hexString = Array.from(randomBytes)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');

    return hexString;
}

export const TIPTAP_VARIABLES: { name: string; text: string; }[] = [
    {
        name: 'Magic Link',
        text: 'magicLink',
    },
    {
        name: 'Applicant Name',
        text: 'applicantName',
    },
    {
        name: 'Client Name',
        text: 'clientName',
    },
]
